import './account-alerts';
import './add';
import './associations';
import './collector-bar';
import './collector-list';
import './connections';
import './create';
import './email-confirmation';
import './notification-prefs';
import './profile-photo';
import './update';
import './update-password';

import './util/check-username.service.js';
import './collector-association.data.js';
import './collector.component.js';
import './collector.controller.js';
import './collector.service.js';
import './_collector.styles.scss';

angular
.module('inkfinder')
.config(function($stateProvider) {
  $stateProvider
  .state('inkfinder.collector', {
    url: '/profile',
    abstract: true,
    views: {
      '@': {
        component: 'inkCollector'
      }
    }
  });
});



// WEBPACK FOOTER //
// ./components/collector/index.js